import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { Definition } from 'app/core/store/definitions/definition.interface';
import { StockCountFilter } from 'app/core/store/stock-count/stock-count-filter.interface';
import { ValidatorService } from '../../../core/services/validator.service';
import { takeUntil } from 'rxjs/operators';
import { Destroyable } from '@dlw-int-mwi/eps-common';
import { BreakpointObserver } from '@angular/cdk/layout';
import { LayoutBreakpoints } from '../../../core/util/layout-breakpoints';

@Component({
  selector: 'app-stock-count-filter',
  templateUrl: './stock-count-filter.component.html',
  styleUrls: ['../../florders/florder-filter/florder-filter.component.scss', './stock-count-filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush, // don't always check for changes, only when input changed (but there's no input here)
})
export class StockCountFilterComponent extends Destroyable implements OnInit, OnChanges {
  filterForm: UntypedFormGroup;
  showDatesIn2rows$ = LayoutBreakpoints.matches(this.breakpointObserver, ...LayoutBreakpoints.tooSmallFor2Fields);
  @Input() filter: StockCountFilter;
  @Input() isLoading: boolean = false;
  @Input() isBusy: boolean = false;
  @Input() shipTos: Definition[];
  @Output() filterStockCounts = new EventEmitter<{ value: StockCountFilter; valid: boolean }>();

  constructor(private validatorService: ValidatorService, private formBuilder: UntypedFormBuilder, private breakpointObserver: BreakpointObserver, cd: ChangeDetectorRef) {
    super();
    // listen to width changes, decide if from-to date fields are shown next to each other or not
    this.showDatesIn2rows$.pipe(
      takeUntil(this.destroyed$),
    ).subscribe(showDatesIn2rows => {
      cd.markForCheck();
    });
  }

  ngOnInit() {
    this.createForm();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.isLoading || changes.isBusy) {
      (this.isLoading || this.isBusy) ? this.filterForm?.disable() : this.filterForm?.enable();
    }
  }

  createForm() {
    const controlsConfig = this.getControlsConfig();
    this.filterForm = this.formBuilder.group(controlsConfig);
  }

  getControlsConfig() {
    return {
      shipTos: [this.filter.shipTos],
      registrationNumber: [this.filter.registrationNumber],
      countDateFrom: [this.filter.countDateFrom, [this.validatorService.datePatternValidator]],
      countDateTo: [this.filter.countDateTo, [this.validatorService.datePatternValidator, this.validatorService.dateSameOrAfter('countDateFrom')]],
    };
  }

  filterClicked() {
    this.filterStockCounts.emit({
      value: {
        ...this.filterForm.value,
      },
      valid: this.filterForm.valid,
    });
  }
}
